import { render, staticRenderFns } from "./createv2.vue?vue&type=template&id=1db556e2&scoped=true&"
import script from "./createv2.vue?vue&type=script&lang=js&"
export * from "./createv2.vue?vue&type=script&lang=js&"
import style0 from "./createv2.vue?vue&type=style&index=0&id=1db556e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db556e2",
  null
  
)

export default component.exports